// import log from 'salvo-lite/log'
// import {AddressForm} from '@shopify/theme-addresses'

class Addresses {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
    }

    onInit () {
        this._addEvents()
        this._slate()
    }

    _addEvents () {
        // code here
    }

    _slate () {
        const selectors = {
            addressContainer: '[data-address]',
            addressFields: '[data-address-fields]',
            addressToggle: '[data-address-toggle]',
            addressForm: 'data-address-form',
            addressDeleteForm: 'data-address-delete-form'
        }
        const hideClass = 'visually-hidden'

        function initializeAddressForm (formID) {
            const deleteForm = document.querySelector('[' + selectors.addressDeleteForm + '="' + formID + '"]')

            document.querySelectorAll(selectors.addressToggle).forEach((button) => {
                button.addEventListener('click', () => {
                    /* Close open forms */
                    document.querySelectorAll('[data-address-form]').forEach((form) => {
                        form.classList.add(hideClass)
                    })

                    /* Open forms */
                    if (button.getAttribute('data-address-toggle').length > 0) {
                        document.querySelector('[data-address-form="' + button.getAttribute('data-address-toggle') + '"]').classList.remove(hideClass)
                    }
                })
            })

            // AddressForm(addressFields, 'en')

            if (deleteForm) {
                deleteForm.addEventListener('submit', (event) => {
                    const confirmMessage = deleteForm.getAttribute('data-confirm-message')

                    if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                        event.preventDefault()
                    }
                })
            }
        }

        const addressForms = document.querySelectorAll(selectors.addressContainer)

        if (addressForms.length) {
            addressForms.forEach((addressContainer) => {
                initializeAddressForm(addressContainer.getAttribute('data-address'))
            })
        }
    }
}

export default Addresses



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Addresses.js